import { render, staticRenderFns } from "./Activtiy.vue?vue&type=template&id=46278fba&scoped=true"
import script from "./Activtiy.vue?vue&type=script&lang=js"
export * from "./Activtiy.vue?vue&type=script&lang=js"
import style0 from "./Activtiy.vue?vue&type=style&index=0&id=46278fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46278fba",
  null
  
)

export default component.exports